import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  OnInit,
  OnChanges,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';
import { FORM_ID } from '../../../helpers/form-id.enum';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { FormRenderComponent } from '../../widgets/form-render/form-render.component';
import { DataViewWithLoaderComponent } from '../data-view-with-loader/data-view-with-loader.component';
import { WorkflowService } from '../../../api/services/workflow.service';

@Component({
  selector: 'app-configuration-cards',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalRendererComponent,
  ],
  templateUrl: './configuration-cards.component.html',
  styleUrl: './configuration-cards.component.css',
})
export class ConfigurationCardsComponent implements OnInit, OnChanges {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() activeModalContext: any;
  @Input() formData: any;
  @Output() buttonClick = new EventEmitter<void>();
  endpoint = environment.api_endpoint;
  nodeId: any;
  noRecord: any;
  api_endpoint = environment.api_endpoint;
  noData = false;
  showValidationError = false;
  fieldsData: any;
  selectedOptions: any[] = [];
  loadingCards = new Set<string>();
  modalTitle = '';
  workflowData: any;
  currentRecordId: any;
  currentNodeId: any;
  currentNode: any;
  recordID: any;
  nextNodes: any;
  targetWorkflowId: any;
  targetValue: any;
  workflowId: any;
  accessToken: any;
  previousNodeId: any;
  private lastTaskMappingSignature = '';
  @ViewChild(FormRenderComponent)
  FormRenderComponent!: FormRenderComponent;
  @ViewChild(DataViewWithLoaderComponent)
  DataViewWithLoaderComponent!: DataViewWithLoaderComponent;
  @ViewChild(ModalRendererComponent) modalRendererRef!: ModalRendererComponent;
  isLoading = true;
  skeletonArray = Array.from({ length: 6 });
  constructor(
    private formService: FormsServiceService,
    private workflowService: WorkflowService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.getData();
    }
  }
  /** Function to get the data by api or static */
  getData() {
    if (this.fields?.options?.isStatic === false) {
      this.fieldsData = this.fields?.options?.staticOptions;
    } else {
      const formId = this.fields?.options?.source?.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields?.options?.source?.method;
      let url = this.fields?.options?.source?.apiUrl;

      // Replace tokens in URL
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService?.replaceTemplateTokens(url, replacements);

      // Add provider query param
      const headers = {
        'Content-Type': 'application/json',
      };

      // ✅ Pass the body to loadData
      this.formService?.loadData(method, url, headers, 30).subscribe({
        next: (res: any) => {
          this.fieldsData = res.data.records;
          this.restoreTagsFromSelectedOptions();
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          if (err.status === 404) {
            this.noData = true;
          }
          this.cdr.detectChanges();
        },
      });
    }
  }
  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  resolvePlaceholders(text: string): string {
    if (!text) return text;

    const placeholderRegex = /{{(.*?)}}/g;

    return text.replace(placeholderRegex, (_match, key) => {
      key = key.trim();

      // 1. direct component property
      if ((this as any)[key] !== undefined) {
        return (this as any)[key];
      }
      // 2. modal context
      if (
        this.activeModalContext &&
        this.activeModalContext[key] !== undefined
      ) {
        return this.activeModalContext[key];
      }

      return _match; // fallback
    });
  }

  handleIntegration(option: any) {
    // Open OAuth/Auth URL in new tab
    if (option.authUrl && option.authUrl.trim() !== '') {
      const authUrl = option.authUrl.replace('{{base}}', this.api_endpoint);

      window.open(authUrl, '_blank');
      return;
    }
    // Handle field dependencies (modal)
    if (option.fieldDependencies && Array.isArray(option.fieldDependencies)) {
      const onClickDep = option.fieldDependencies.find(
        (dep: any) => dep.trigger === 'onClick',
      );

      if (onClickDep && Array.isArray(onClickDep.condition)) {
        for (const condBlock of onClickDep.condition) {
          const modalCond = condBlock.conditions?.find(
            (c: any) =>
              c.type === 'modal' && c.targetType === 'form' && c.targetValue,
          );

          if (modalCond) {
            const modalContext = {
              nodeId: modalCond.targetValue,
              record: 'add',
            };

            this.nodeId = modalCond.targetValue;
            this.noRecord = modalContext.record;
            this.activeModalContext = modalContext;

            const modal = document.getElementById(
              'open_smtp_modal_' + this.fields?.fieldName,
            );

            if (modal) {
              modal.classList.add('show');
            }

            return;
          }
        }
      }
    }
  }

  restoreTagsFromSelectedOptions() {
    if (!this.fieldsData?.length) return;

    const currentValue = (this.fields?.value || []).map((v: any) =>
      v.toString(),
    );

    // Find matching options
    const selectedOptions = this.fieldsData.filter((opt: any) =>
      currentValue.includes(opt._id?.toString()),
    );

    // Extract ids
    const restoredIds = selectedOptions.map((opt: any) => opt._id.toString());

    // Set ids in main control
    this.control?.setValue(restoredIds, { emitEvent: false });

    // Extract names
    const selectedNames = selectedOptions.map((opt: any) => opt.name);

    // Tags control name
    const tagsControlName = this.fields.fieldName + 'Tags';

    // Get tags control
    const tagsControl = this.formGroup.get(tagsControlName);

    // ✅ Set tags only if control exists
    if (tagsControl) {
      tagsControl.setValue(selectedNames, { emitEvent: false });
      tagsControl.updateValueAndValidity();
    }
  }

  // isSelected(option: any): boolean {
  //   const controlValue = this.normalizeSelectionValue(this.control?.value);
  //   const values = controlValue.length
  //     ? controlValue
  //     : this.normalizeSelectionValue(this.fields?.value);
  //   return values.includes(option?._id?.toString());
  // }
  isSelected(option: any): boolean {
    const control = this.formGroup.get(this.fields.fieldName);

    const values = this.normalizeSelectionValue(control?.value || []);

    return values.includes(option?._id?.toString());
  }

  private normalizeSelectionValue(value: any): string[] {
    if (!value) return [];

    const values = Array.isArray(value) ? value : [value];
    return values
      .map((v: any) =>
        typeof v === 'object' ? v?._id?.toString() : v?.toString(),
      )
      .filter(Boolean);
  }

  /** Function to toggle the card and push the selection into array */
  toggleSelection(option: any): void {
    const optionId = option?._id?.toString();

    if (!optionId) return;

    const control = this.formGroup.get(this.fields.fieldName);

    if (!control) {
      return;
    }

    const tagsControl = this.formGroup.get(`${this.fields.fieldName}Tags`);

    const currentValues = this.normalizeSelectionValue(control.value);

    const alreadySelected = currentValues.includes(optionId);

    // 🔁 Deselect
    if (alreadySelected) {
      this.resetSelection(optionId, tagsControl);
      return;
    }

    // ✅ Prevent selecting another option in singleSelect
    if (this.fields?.fieldType === 'singleSelect' && currentValues.length > 0) {
      return;
    }

    this.loadingCards.add(optionId);

    // 🧩 Handle workflow modal dependency
    if (this.handleWorkflowModal(option)) {
      this.loadingCards.delete(optionId);
      return;
    }

    // ✅ Direct activation without workflow
    if (!option.fieldDependencies) {
      control.setValue([optionId]);
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();

      tagsControl?.setValue([option.name]);
      tagsControl?.updateValueAndValidity();
    }
  }

  resetSelection(optionId: string, tagsControl: any): void {
    const control = this.formGroup.get(this.fields.fieldName);

    if (!control) return;

    control.setValue(null);
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: true });

    tagsControl?.setValue(null);
    tagsControl?.updateValueAndValidity({ emitEvent: true });

    this.selectedOptions = [];

    this.loadingCards.delete(optionId);
  }

  handleWorkflowModal(option: any): boolean {
    const fieldDeps = option?.fieldDependencies || [];
    const onClickDep = fieldDeps.find((d: any) => d.trigger === 'onClick');
    if (!onClickDep?.condition) return false;

    for (const block of onClickDep.condition) {
      const modalCond = block.conditions?.find(
        (c: any) =>
          c.type === 'modal' && c.targetType === 'workflow' && c.targetValue,
      );

      if (!modalCond) continue;

      this.activeModalContext = {
        workflowId: modalCond.targetValue,
        selectedOption: option,
        authUrl: option.integration?.authUrl,
        selectedName: option.name,
        fieldName: this.fields.fieldName,
        currentSelectedName:
          option.name == 'Cloud Computing' ? 'GCP' : option.name,
      };

      this.loadWorkflow(modalCond.targetValue, 0);

      const modal = document.getElementById(
        `connection_modal_${this.fields.fieldName}`,
      );
      modal?.classList.add('show');

      return true;
    }

    return false;
  }

  openIntegrationAuth(option: any): void {
    const authTemplate = option?.integration?.authUrl;
    if (!authTemplate) return;

    this.accessToken = localStorage.getItem('accessToken') || '';
    let authUrl = authTemplate.replace('{{base}}', this.endpoint);

    const separator = authUrl.includes('?') ? '&' : '?';
    authUrl += `${separator}at=${encodeURIComponent(this.accessToken)}`;

    window.open(authUrl, '_blank');
  }

  /** Loads the workflow and optionally a specific node */
  loadWorkflow(wId: string, nodeId?: any, nodeIndex?: any): void {
    this.workflowData = null;
    this.workflowService.loadWorkflow(wId).subscribe({
      next: ({ workflowData, recordId }) => {
        this.workflowData = workflowData;
        this.currentRecordId = recordId;
        this.workflowId = wId;
        this.cdr.markForCheck();
        // --- Handle second last node request ---
        if (nodeIndex === 'secondLastNode') {
          const nodes = workflowData?.nodes || [];

          if (nodes.length >= 2) {
            const secondLastNode = nodes[nodes.length - 2]; // ⭐ correct node
            this.currentNodeId = secondLastNode._id;
            this.loadNode(secondLastNode._id, recordId);
            return; // ⭐ STOP HERE, do NOT load startNodeId
          }
        }
        // --- Default start node logic ---
        const startNodeId = workflowData?.startNodeId;
        if (startNodeId) {
          this.currentNodeId = startNodeId;
          this.loadNode(startNodeId, recordId);
        } else {
          console.warn(`[Workflow] No startNodeId found for workflow: ${wId}`);
        }
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.cdr.detectChanges();
      },
    });
  }

  /** Loads a node and processes navigation-related metadata */
  loadNode(nodeId: string, recordId?: string): void {
    if (this.activeModalContext?.nodeId === nodeId) {
      this.currentNodeId = nodeId;
      this.currentNode = null;
      this.nextNodes = null;
      this.targetWorkflowId = null;
      return;
    }
    const node = this.workflowData?.nodes?.find((n: any) => n._id === nodeId);
    if (!node) {
      return;
    }

    this.currentNode = node;
    this.currentNodeId = node._id;
    this.recordID = node.recordId || recordId;
    this.loadPreviousNode();
    const nextNodeIndex = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id === this.currentNode?._id,
    );

    const lastNodeIndex = this.workflowData?.nodes?.length - 1;
    const isLastNode = nextNodeIndex === lastNodeIndex;
    if (this.activeModalContext) {
      this.activeModalContext.lastNode = isLastNode;
    }
    const nextButtonObj =
      node.next?.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next?.[0];

    if (!nextButtonObj) return;

    const condition = nextButtonObj.condition;
    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          this.nextNodes = cond.targetValue;
          return;
        }
        if (cond?.targetNodeId) {
          this.nextNodes = cond.targetNodeId;
          return;
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          this.targetValue = cond.targetValue;
          return;
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          this.targetWorkflowId = cond.targetValue;
          return;
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        this.nextNodes = nextButtonObj.targetValue;
      } else if (nextButtonObj.targetNodeId) {
        this.nextNodes = nextButtonObj.targetNodeId;
      } else if (
        nextButtonObj.targetType === 'url' &&
        nextButtonObj.targetValue
      ) {
        this.targetValue = nextButtonObj.targetValue;
      } else if (
        nextButtonObj.targetType === 'workflow' &&
        nextButtonObj.targetValue
      ) {
        this.targetWorkflowId = nextButtonObj.targetValue;
      } else {
        console.warn(`[Workflow] No valid condition in nextButtonObj.`);
      }
    } else {
      console.warn(`[Workflow] Invalid or missing condition in node.`);
    }
  }

  /** Function to validate the card is selected or not then show error message */
  validateSelection(): boolean {
    const currentValue = (this.control?.value || []).map((v: any) =>
      v.toString(),
    );

    if (currentValue.length > 0) {
      this.showValidationError = false;
      return true;
    }

    if (this.fields.isRequired) {
      this.showValidationError = true;
      return false;
    }

    this.showValidationError = false;
    return true;
  }

  closeOnBackdropClick(event: MouseEvent, modalId: string) {
    const modal = document.getElementById(modalId);
    if (event.target === modal) {
      this.closeModal(modalId);
    }
  }

  closeModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
    this.stopPollingFromModalRenderer();
    this.currentNodeId = null;
    this.currentNode = null;
    this.workflowData = null;
    this.recordID = null;
    this.workflowId = null;
    this.currentRecordId = null;
    this.modalTitle = '';
  }

  stopPollingFromModalRenderer() {
    if (this.modalRendererRef) {
      this.modalRendererRef.stopChildPolling();
    }
  }

  onModalFormSaved(event: any): void {
    const optionId = this.activeModalContext?.selectedOption?._id;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    if (event?.success) {
      const option = this.activeModalContext?.selectedOption;
      if (option && option.name) {
        console.log(`✅ Connection completed for: ${option.name}`);
      }

      const { nextNodeId, targetValue, targetWorkflowId, isSseTrigger } =
        this.resolveNavigationTargets(this.currentNode);

      const currentIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === this.currentNode?._id,
      );
      const lastNode = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === nextNodeId,
      );
      const lastNodeIndex = this.workflowData?.nodes?.length - 1;
      const nextNodeIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === nextNodeId,
      );
      const isLastNode = currentIndex === lastNodeIndex;
      const isSecondOrThirdNode =
        currentIndex === 1 ||
        currentIndex === 2 ||
        currentIndex == lastNodeIndex;
      const isNextNodeTheLastNode = nextNodeIndex === lastNodeIndex;

      // 🔥 NEW: Mark selected when NEXT NODE is the LAST node
      if (isNextNodeTheLastNode && !isLastNode) {
        const newValue = [this.activeModalContext?.selectedOption?._id];
        const newTags = [this.activeModalContext?.selectedOption?.name];

        this.control?.setValue(newValue);
        tagsControl?.setValue(newTags);

        this.currentNode.selectedOptions = newValue;
        this.workflowData.selectedOptions = newValue;

        this.control?.markAsTouched();
        this.control?.updateValueAndValidity();

        this.loadingCards.delete(optionId);
      }

      // ✅ When reaching last node
      if (isLastNode) {
        const newValue = [this.activeModalContext?.selectedOption?._id];
        const newTags = [this.activeModalContext?.selectedOption?.name];

        this.control?.setValue(newValue);
        tagsControl?.setValue(newTags);
        this.selectedOptions = [...newValue];

        this.control?.markAsTouched();
        this.control?.updateValueAndValidity();

        this.loadingCards.delete(optionId);
        this.currentNode.selectedOptions = this.selectedOptions;
        this.workflowData.selectedOptions = this.selectedOptions;
        this.selectedOptions = [...newValue];
      }

      // ✅ Handle workflow transitions
      if (nextNodeId && !isSseTrigger) {
        this.loadNode(nextNodeId);
        return;
      }

      if (targetValue) {
        const token = localStorage.getItem('accessToken');
        if (token) {
          window.location.href = `${targetValue}/${token}`;
          return;
        }
      }

      if (targetWorkflowId) {
        this.loadWorkflow(targetWorkflowId);
        return;
      }

      // 🔁 SSE Trigger
      if (isSseTrigger) {
        const sseTrigger = this.currentNode?.triggers?.find(
          (trigger: any) => trigger.event === 'listenSSE',
        );
        if (sseTrigger?.config?.url && sseTrigger?.config?.nextNodeId) {
          const apiEndpoint = environment.api_endpoint;
          const authToken = localStorage.getItem('accessToken') || '';
          const resolvedUrl = sseTrigger.config.url
            .replace('{{api_endpoint}}', apiEndpoint)
            .replace('{{authToken}}', authToken);

          // this.SseService.initSSE(resolvedUrl);
          this.loadNode(sseTrigger.config.nextNodeId);
          return;
        }
      }

      // ✅ Close modal properly
      const modalId = `connection_modal_${this.fields.fieldName}`;
      this.closeModal(modalId);
    }
  }

  /** Resolves navigation targets from current node */
  resolveNavigationTargets(node: any): {
    nextNodeId: string | null;
    targetValue: string | null;
    targetWorkflowId: string | null;
    recordId: string | null;
    isSseTrigger?: boolean;
  } {
    const fallback = {
      nextNodeId: null,
      targetValue: null,
      targetWorkflowId: null,
      recordId: node?.recordId ?? null,
      isSseTrigger: false,
    };

    if (!node?.next || !Array.isArray(node.next)) return fallback;

    const nextButtonObj =
      node.next.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next[0];

    if (!nextButtonObj) return fallback;

    const resolveSseTrigger = (): {
      nextNodeId: string | null;
      isSseTrigger: boolean;
    } => {
      const sseTrigger = node.triggers?.find(
        (trigger: any) => trigger.event === 'listenSSE',
      );
      if (sseTrigger?.config?.nextNodeId) {
        return { nextNodeId: sseTrigger.config.nextNodeId, isSseTrigger: true };
      }
      return { nextNodeId: null, isSseTrigger: false };
    };

    const condition = nextButtonObj.condition;

    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          return { ...fallback, nextNodeId: cond.targetValue };
        }
        if (cond?.targetNodeId) {
          return { ...fallback, nextNodeId: cond.targetNodeId };
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          return { ...fallback, targetValue: cond.targetValue };
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          return { ...fallback, targetWorkflowId: cond.targetValue };
        }
        if (cond?.targetType === 'manual') {
          const { nextNodeId, isSseTrigger } = resolveSseTrigger();
          if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        return { ...fallback, nextNodeId: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetNodeId) {
        return { ...fallback, nextNodeId: nextButtonObj.targetNodeId };
      }
      if (nextButtonObj.targetType === 'url' && nextButtonObj.targetValue) {
        return { ...fallback, targetValue: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetType === 'manual') {
        const { nextNodeId, isSseTrigger } = resolveSseTrigger();
        if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
      }
    }
    return fallback;
  }

  /** Function to set the modal title */
  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  /** Loads previous node info for back navigation */
  loadPreviousNode(): void {
    const prevBtn = this.currentNode?.previous?.find(
      (p: any) => p.buttonId === 'previous_button',
    );
    if (prevBtn?.targetNodeId) {
      this.previousNodeId = prevBtn.targetNodeId;
    } else {
      console.warn('[Workflow] Previous button or targetNodeId not found.');
    }
  }

  clickedOnPrevious() {
    const currentNode = this.workflowData.nodes.find(
      (n: any) => n._id === this.currentNodeId,
    );

    if (
      currentNode &&
      currentNode.previous &&
      currentNode.previous.length > 0
    ) {
      const { targetNodeId } = currentNode.previous[0];
      if (targetNodeId) {
        this.workflowData.currentNodeId = targetNodeId;
        this.loadNode(targetNodeId);
      }
    } else {
      console.warn(
        'No previous node found for:',
        this.workflowData.currentNodeId,
      );
    }
  }

  checkPollingServiceForError(value: any) {
    // 🔍 Find the "attempts" condition in the current node’s next array
    const attemptNode = this.currentNode?.next?.find((next: any) =>
      next.condition.some((condGroup: any) =>
        condGroup.conditions.some((cond: any) => cond.type === 'attempts'),
      ),
    );

    if (attemptNode) {
      const targetNodeId = attemptNode?.condition?.[0]?.targetValue;
      const targetType = attemptNode?.condition?.[0]?.targetType;
      if (targetType === 'node' && targetNodeId) {
        this.loadNode(targetNodeId);
      } else if (targetType === 'workflow' && targetNodeId) {
        this.loadWorkflow(targetNodeId);
      } else {
        console.warn('⚠️ No valid target found for attempts condition');
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.fields.fieldName) {
      this.closeModal('connection_modal_' + this.fields.fieldName);
    }
  }

  /** Function to disable another cards  */
  isDisabled(option: any): boolean {
    if (this.fields?.fieldType !== 'singleSelect') {
      return false;
    }

    const control = this.formGroup.get(this.fields.fieldName);

    const values = this.normalizeSelectionValue(control?.value || []);

    return values.length > 0 && !values.includes(option?._id?.toString());
  }
}
